<p-panel header="{{'fs.res.publication.Publication.access' | hisUi}}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<!-- check if publicationType is not null -->
	<div *ngIf="publication.publicationType">
		<!-- Zugangsrecht -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('access')"
				[(ngModel)]="publication.access"  hisEagerDataSource="publicationAccessTypeValue"
				(onClear)="onClear('access')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('access')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Embargodatum -->
		<his-plam>
            <p-calendar [hisDdKey]="getDdKey('embargoDate')" #content [(ngModel)]="publication.embargoDate"></p-calendar>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('embargoDate')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Zugangsrecht nach Ablauf des Embargos -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('accessAfterEmbargoDate')"
				[(ngModel)]="publication.accessAfterEmbargoDate"  hisEagerDataSource="publicationAccessTypeValue"
				(onClear)="onClear('accessAfterEmbargoDate')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('accessAfterEmbargoDate')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Lizenz -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('license')"
				[(ngModel)]="publication.license"  hisEagerDataSource="licenseValue"
				(onClear)="onClear('license')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('license')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>
    </div>
</p-panel>
